(function () {
  'use strict';

  /* ===== Image Gallery ===== */
  const main = document.querySelector('[data-ds-main-image]');
  const slider = document.querySelector('[data-ds-slider]');
  const slides = document.querySelectorAll('[data-ds-image-slide]');
  const thumbs = document.querySelectorAll('[data-ds-thumb]');
  const dots = document.querySelectorAll('[data-ds-dot]');

  function showSlide(idx) {
    slides.forEach(s => s.classList.toggle('is-active', parseInt(s.dataset.index) === idx));
    thumbs.forEach(t => t.classList.toggle('is-active', parseInt(t.dataset.index) === idx));
    dots.forEach(d => d.classList.toggle('is-active', parseInt(d.dataset.index) === idx));
  }
  thumbs.forEach(t => {
    t.addEventListener('click', () => showSlide(parseInt(t.dataset.index)));
  });

  /* Mobile swipe: dots follow scroll position, tapping a dot scrolls to that slide */
  dots.forEach(d => {
    d.addEventListener('click', () => {
      const idx = parseInt(d.dataset.index);
      showSlide(idx);
      if (slider) slider.scrollTo({ left: idx * slider.clientWidth, behavior: 'smooth' });
    });
  });
  if (slider) {
    let scrollTimer;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (slider.clientWidth === 0 || slider.scrollWidth <= slider.clientWidth) return;
        showSlide(Math.round(slider.scrollLeft / slider.clientWidth));
      }, 80);
    }, { passive: true });
  }

  /* ===== Quantity Stepper ===== */
  const qtyInput = document.querySelector('[data-ds-qty]');
  const qtyDown = document.querySelector('[data-ds-qty-down]');
  const qtyUp = document.querySelector('[data-ds-qty-up]');
  if (qtyDown && qtyInput) qtyDown.addEventListener('click', () => {
    const v = Math.max(1, parseInt(qtyInput.value) - 1);
    qtyInput.value = v;
  });
  if (qtyUp && qtyInput) qtyUp.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  /* ===== Variant Picker ===== */
  const optionPills = document.querySelectorAll('[data-ds-option]');
  const variantSelect = document.querySelector('[data-ds-variant-select]');

  function getSelectedOptions() {
    const selected = {};
    document.querySelectorAll('.ds-pdp__option-pill.is-active').forEach(p => {
      selected[p.dataset.optionPosition] = p.dataset.optionValue;
    });
    return selected;
  }

 function updateVariant() {
  if (!variantSelect) return;

  const selected = getSelectedOptions();
  const options = Array.from(variantSelect.options);

  const match = options.find(opt => {
    return (
      (!selected["1"] || opt.text.includes(selected["1"])) &&
      (!selected["2"] || opt.text.includes(selected["2"])) &&
      (!selected["3"] || opt.text.includes(selected["3"]))
    );
  });

  if (!match) {
    console.warn('No variant match found');
    return;
  }

  variantSelect.value = match.value;

  const price = parseInt(match.dataset.price);
  const comparePrice = parseInt(match.dataset.comparePrice) || 0;
  const available = match.dataset.available === 'true';

  const priceEl = document.querySelector('[data-ds-price-display]');
  if (priceEl) priceEl.textContent = formatMoney(price);

  const compareEl = document.querySelector('[data-ds-compare-display]');
  const savePillEl = document.querySelector('[data-ds-save-pill]');
  if (compareEl) {
    if (comparePrice > price) {
      compareEl.textContent = formatMoney(comparePrice);
      compareEl.style.display = '';
      if (savePillEl) {
        savePillEl.textContent = 'SAVE ' + formatMoney(comparePrice - price);
        savePillEl.style.display = '';
      }
    } else {
      compareEl.style.display = 'none';
      if (savePillEl) savePillEl.style.display = 'none';
    }
  }

  const stockWrap = document.querySelector('[data-ds-stock]');
  if (stockWrap) {
    const qty = parseInt(match.dataset.inventory, 10) || 0;
    const managed = match.dataset.managed === 'true';
    if (!available) {
      stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--out">
          <span class="ds-pdp__stock-dot"></span>
          Currently out of stock
        </div>`;
    } else if (managed && qty > 0 && qty <= 10) {
      stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--low">
          <span class="ds-pdp__stock-dot"></span>
          Only <strong>${qty}</strong> left in stock — order soon
        </div>`;
    } else {
      stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--in">
          <span class="ds-pdp__stock-dot"></span>
          In stock — ready to dispatch from Riyadh
        </div>`;
    }
  }

  const atcBtn = document.querySelector('[data-ds-atc]');
  const atcText = document.querySelector('.ds-pdp__atc-text');

  if (atcBtn) {
    atcBtn.disabled = !available;
    if (atcText) {
      atcText.textContent = available
        ? `Add to Cart — ${formatMoney(price)}`
        : 'Sold Out';
    }
  }
}

  
  optionPills.forEach(pill => {
    pill.addEventListener('click', () => {
      const pos = pill.dataset.optionPosition;
      document.querySelectorAll(`[data-option-position="${pos}"]`).forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      const valueEl = document.querySelector(`[data-option-value="${pos}"]`);
      if (valueEl) valueEl.textContent = pill.dataset.optionValue;
      updateVariant();
    });
  });

  updateVariant();

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const fmt = window.DS_MONEY_FORMAT || '£{{amount}}';
    return fmt.replace('{{amount}}', amount);
  }

  /* ===== Tabs ===== */
  const tabBtns = document.querySelectorAll('[data-ds-tab-trigger]');
  const tabPanels = document.querySelectorAll('[data-ds-tab-panel]');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.dsTabTrigger;
      tabBtns.forEach(b => b.classList.toggle('is-active', b === btn));
      tabPanels.forEach(p => p.classList.toggle('is-active', p.dataset.dsTabPanel === target));
    });
  });

  /* ===== Mobile Accordion (tabs collapse to accordion <=640px) ===== */
  document.querySelectorAll('[data-ds-acc]').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = document.querySelector(`[data-ds-tab-panel="${btn.dataset.dsAcc}"]`);
      const open = btn.classList.toggle('is-open');
      if (panel) panel.classList.toggle('is-open', open);
    });
  });

  /* ===== AJAX Add to Cart ===== */
  const form = document.getElementById('ds-product-form');
  const atcBtn = document.querySelector('[data-ds-atc]');

  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      // Allow Buy Now (name="checkout") to submit normally
      if (e.submitter && e.submitter.name === 'checkout') return;

      e.preventDefault();
      const formData = new FormData(form);
      const originalText = atcBtn.querySelector('.ds-pdp__atc-text').textContent;
      atcBtn.dataset.loading = 'true';
      atcBtn.querySelector('.ds-pdp__atc-text').textContent = 'Adding…';

      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || 1, 10);

     fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  body: JSON.stringify({
    items: [{ id: parseInt(variantId, 10), quantity }],
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: window.location.pathname
  })
})
.then(async (r) => {
  const text = await r.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch(e) {
    console.error('Non-JSON response from /cart/add.js:', text.substring(0, 200));
    throw new Error('Cart error — unexpected server response');
  }
  if (!r.ok) throw new Error(data.description || 'Add to cart failed');
  return data;
})
.then(data => {
  atcBtn.dataset.loading = 'false';
  atcBtn.dataset.added = 'true';
  atcBtn.querySelector('.ds-pdp__atc-text').textContent = '✓ Added to Cart';

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && data.sections) {
    cartDrawer.renderContents({ id: variantId, sections: data.sections });
  }

  setTimeout(() => {
    atcBtn.dataset.added = 'false';
    atcBtn.querySelector('.ds-pdp__atc-text').textContent = originalText;
    atcBtn.disabled = false;
  }, 2500);
})
.catch(err => {
  atcBtn.dataset.loading = 'false';
  atcBtn.disabled = false;
  atcBtn.querySelector('.ds-pdp__atc-text').textContent = originalText;
  console.error('[DS ATC]', err.message);
  alert(err.message);
});
    });
  }


  /* ===== Sticky Mobile Bar ===== */
  const stickyBar = document.querySelector('[data-ds-sticky-bar]');
  const stickyAtc = document.querySelector('[data-ds-sticky-atc]');
  const mainAtc = document.querySelector('[data-ds-atc]');

   if (stickyBar && mainAtc) {
    let hasIntersected = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) hasIntersected = true;
        if (hasIntersected) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        }
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }
  if (stickyAtc && mainAtc) {
    stickyAtc.addEventListener('click', () => {
      mainAtc.click();
      window.scrollTo({ top: mainAtc.getBoundingClientRect().top + window.scrollY - 200, behavior: 'smooth' });
    });
  }
  /* ===== Initialize variant state on page load ===== */
(function initVariant() {
  const variantSelectEl = document.querySelector('[data-ds-variant-select]');
  if (!variantSelectEl) return;

  const selected = variantSelectEl.options[variantSelectEl.selectedIndex];
  if (!selected) return;

  const price     = parseInt(selected.dataset.price) || 0;
  const available = selected.dataset.available === 'true';
  const atcText   = document.querySelector('.ds-pdp__atc-text');
  const atcBtn    = document.querySelector('[data-ds-atc]');

  if (atcBtn) {
    atcBtn.disabled = !available;
    if (atcText) {
      atcText.textContent = available
        ? 'Add to Cart — ' + formatMoney(price)
        : 'Sold Out';
    }
  }
})();

  /* ===== Frequently Bought Together ===== */
  /* Widget is rendered server-side from precomputed metafields (see ds-product.liquid) —
     this just wires up the checkbox totals + combined add-to-cart. */
  (function initFBT() {
    const wrap = document.querySelector('[data-ds-fbt]');
    if (!wrap) return;

    const row = wrap.querySelector('[data-ds-fbt-row]');
    const totalEl = wrap.querySelector('[data-ds-fbt-total]');
    const totalOriginalEl = wrap.querySelector('[data-ds-fbt-total-original]');
    const savingsEl = wrap.querySelector('[data-ds-fbt-savings]');
    const addBtn = wrap.querySelector('[data-ds-fbt-add]');
    const checkboxes = row.querySelectorAll('[data-ds-fbt-check]');
    const discountPct = parseInt(wrap.dataset.dsFbtDiscountPct || '0', 10);

    function updateTotal() {
      const checked = Array.from(row.querySelectorAll('[data-ds-fbt-check]:checked'));
      const total = checked.reduce((sum, cb) => sum + parseInt(cb.dataset.price, 10), 0);

      const requiredCbs = Array.from(row.querySelectorAll('[data-ds-fbt-required]'));
      const allRequiredChecked = requiredCbs.length > 0 && requiredCbs.every(cb => cb.checked);

      if (discountPct > 0 && allRequiredChecked) {
        const discounted = Math.round(total * (100 - discountPct) / 100);
        totalOriginalEl.textContent = formatMoney(total);
        totalOriginalEl.hidden = false;
        totalEl.textContent = formatMoney(discounted);
        savingsEl.textContent = 'You save ' + formatMoney(total - discounted);
        savingsEl.hidden = false;
      } else {
        totalOriginalEl.hidden = true;
        totalEl.textContent = formatMoney(total);
        savingsEl.hidden = true;
      }

      addBtn.textContent = 'Add ' + checked.length + ' Item' + (checked.length !== 1 ? 's' : '') + ' to Cart';
      addBtn.disabled = checked.length < 2;
    }

    checkboxes.forEach(cb => cb.addEventListener('change', updateTotal));
    updateTotal();

    addBtn.addEventListener('click', () => {
      const checked = Array.from(row.querySelectorAll('[data-ds-fbt-check]:checked'));
      const cartItems = checked.map(cb => ({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 }));
      if (cartItems.length < 2) return;

      const originalText = addBtn.textContent;
      addBtn.dataset.loading = 'true';
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: cartItems, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      })
      .then(r => r.json())
      .then(data => {
        addBtn.dataset.loading = 'false';
        addBtn.textContent = '✓ Added';
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && data.sections) cartDrawer.renderContents({ sections: data.sections });
        setTimeout(() => { addBtn.textContent = originalText; }, 2000);
      })
      .catch(() => {
        addBtn.dataset.loading = 'false';
        addBtn.textContent = originalText;
      });
    });
  })();
})();
